var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatsLocalisationsTableComponent',{attrs:{"table-datas":_vm.tableDatas,"is-loading-table-data":_vm.isLoadingTableData,"title":"Nombre moyen de nuitées par département / commune / arrondissements","table-columns":_vm.tableColumns}})}
var staticRenderFns = []

export { render, staticRenderFns }